module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/vip-icons-05-a291c1fe98c4fa73fb3d9bab34dcbfe1.png";